import React from 'react';

interface TeamMemberProps {
    src: string;
    alt: string;
    flex?: boolean;
}

export const TeamMember: React.FC<TeamMemberProps> = React.memo(
    ({ src, alt, flex }) => (
        <div className={`about__team__grid__member ${flex && 'flex'}`}>
            <img src={src} alt={alt} className='about__team__grid__member__image' />
            <p className='about__team__grid__member__name'>{alt}</p>
        </div>
    )
);
